import z from 'zod'

export const createCameraFormSchema = z.object({
  schoolId: z.string().min(1, { message: 'Поле не может быть пустым' }),
  schoolBin: z.string().min(1, { message: 'Поле не может быть пустым' }),
  targetaiSchoolId: z.string().min(1, { message: 'Поле не может быть пустым' }),
  targetaiCameraId: z.string().min(1, { message: 'Поле не может быть пустым' }),
  cameraTypeId: z.string().min(1, { message: 'Поле не может быть пустым' }),
  active: z.enum(['true', 'false']),
})
